import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions, Person } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class PersonListProvider implements Resolve<any> {
    person: Person[];
    personEdit: Person;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.personEdit = this.state?.currentPerson;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "name";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number) {
        if (!id) {
            return null;
        }
        return new Promise<any>((resolve, reject) => {
            this.gw.get("person/:id", { id: id }).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res.body);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
        // return this.gw.get('person/:id', { id: id });
    }

    getByCPf(cpf: string) {
        if (!cpf) {
            return null;
        }
        return new Promise<any>((resolve, reject) => {
            this.gw.get("person/cpf/:cpf", { cpf: cpf }).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res.body);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
        // return this.gw.get('person/:id', { id: id });
    }

    get currentPerson(): Person {
        return this.personEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("person/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.person = res.body;
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("person/search", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.person, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.person = res.body.content;
                        this.onDataChanged.next(this.person);
                    } else {
                        this.person = res.body.content;
                    }
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getPersonPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("person/search/page", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.person, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.person = res.body.content;
                        this.onDataChanged.next(this.person);
                    } else {
                        this.person = res.body.content;
                    }
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getContactList(personId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("person/:personId/contactList", { personId: personId })
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res.body ? res.body : res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
